import * as Yup from 'yup';

export const writerFormYopValidation = () => {
  return Yup.object().shape({
    writerPhrase: Yup.string().required('required'),
    language: Yup.string().required('required'),
    writerName: Yup.string().required('required'),
    writerColor: Yup.string().required('required'),
  });
};
